// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"routes_switchContainer__3FbLB"};